import React, { useState, useEffect } from 'react';

const EditGameGroupModal = ({ groupId, onClose, onUpdate }) => {
  const [name, setName] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await fetch(`/game_groups/${groupId}.json`);
        if (!response.ok) throw new Error('Failed to fetch game group');
        const group = await response.json();
        if (group && group.id) {
          setName(group.name);
          setImageUrl(group.image_url || '');
        } else {
          throw new Error('Game group not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGroup();
  }, [groupId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    try {
      const response = await fetch(`/game_groups/${groupId}.json`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ game_group: { name, image_url: imageUrl } }),
      });

      const data = await response.json();

      if (response.ok) {
        onUpdate(data);
      } else {
        setError(data.errors ? Object.values(data.errors).flat().join(', ') : 'Failed to update group.');
      }
    } catch (error) {
      setError('An unexpected error occurred.');
    }
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <article className="modal-content" onClick={(e) => e.stopPropagation()} aria-busy="true">
          Loading group...
        </article>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Edit Game Group</h2>
          <button aria-label="Close" className="close-button" onClick={onClose}>&times;</button>
        </header>
        {error && <p style={{ color: 'var(--pico-color-red-550)' }}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <label htmlFor="name">Group Name</label>
          <input type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
          <label htmlFor="image_url">Image URL</label>
          <input
            type="text"
            id="image_url"
            name="image_url"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            placeholder="Optional"
          />
          <button type="submit">Update Group</button>
        </form>
      </article>
    </div>
  );
};

export default EditGameGroupModal;